import runningRemote from 'products/global/assets/img/partners/runningRemote.png';
import nomadList from 'products/global/assets/img/partners/nomadList.png';
import superside from 'products/global/assets/img/partners/superside.png';
import dearAlyne from 'products/global/assets/img/partners/dearAlyne.png';
import workew from 'products/global/assets/img/partners/workew.png';
import nomadSummit from 'products/global/assets/img/partners/nomadSummit.png';
import ruul from 'products/global/assets/img/partners/ruul.png';
import theBrokeBackpacker from 'products/global/assets/img/partners/thebrokebackpacker.png';
import eResidency from 'products/global/assets/img/partners/eResidency.png';
import hoboWithALaptop from 'products/global/assets/img/partners/hoboWithALaptop.png';
import hackerParadise from 'products/global/assets/img/partners/hackerParadise.png';
import coWorker from 'products/global/assets/img/partners/coWorker.png';
import soloFemale from 'products/global/assets/img/partners/soloFemale.png';
import moneyCheck from 'products/global/assets/img/partners/moneyCheck.png';
import xolo from 'products/global/assets/img/partners/xolo.png';
import planetNomad from 'products/global/assets/img/partners/planetNomad.png';
import remoteTools from 'products/global/assets/img/partners/remoteTools.png';
import outsite from 'products/global/assets/img/partners/outsite.png';
import aBrokenBackpack from 'products/global/assets/img/partners/aBrokenBackpack.png';
import oysterhr from 'products/global/assets/img/partners/oyster.png';
import panther from 'products/global/assets/img/partners/panther.jpg';
import nexstand from 'products/global/assets/img/partners/nexstand.png';
import firstbase from 'products/global/assets/img/partners/firstbase.png';
import talanta from 'products/global/assets/img/partners/talanta.png';
import techstars from 'products/global/assets/img/partners/techstars.png';
import flatworld from 'products/global/assets/img/partners/flatworld.png';

export default [
  {
    name: 'Oyster',
    description:
      'Oyster is a global employment platform that helps fast-growing companies manage remote work and international hiring seamlessly.',
    website: 'https://www.oysterhr.com/',
    logo: oysterhr
  },
  {
    name: 'Panther',
    website: 'https://www.panther.co/panther-for-startups',
    description:
      'Automated global payroll & compliance for remote teams. Save with up to $20,000 in Panther Credits.',
    logo: panther
  },
  {
    name: 'Running Remote',
    description:
      'Running Remote is an exclusive event for the founders of remote businesses. Learn the strategies for managing and scaling distributed teams, and build new business partnerships.',
    website: 'http://runningremote.com',
    logo: runningRemote
  },
  {
    name: 'Remote Tools',
    description:
      'Remote Tools is a community for learning, discussing and promoting remote work.',
    website: 'https://remote.tools/',
    logo: remoteTools
  },
  {
    name: 'PlanetNomad',
    description: 'Nomad resources in Spanish, French and Portuguese.',
    website: 'https://www.planet-nomad.com/',
    logo: planetNomad
  },
  {
    name: 'Nomad List',
    description:
      'Nomad List finds the best places to live and work remotely for digital nomads, based on cost of living, internet speed and other useful data.',
    website: 'https://nomadlist.com',
    logo: nomadList
  },
  {
    name: 'Superside',
    description:
      'Superside lets you pass on any graphic design project to them, and their top freelancers will ship the result within 24 hours.',
    website: 'https://www.superside.com/',
    logo: superside
  },
  {
    name: 'Dear Aylne',
    description:
      'Dear Alyne is a Facebook show that discusses relevant issues from around the world.',
    website: 'https://dearalyne.com',
    logo: dearAlyne
  },
  {
    name: 'Workew',
    description:
      'Workew is a remote-job board and hiring platform that connects talented people who seek remote careers with innovative companies hiring remotely.',
    website: 'https://workew.com',
    logo: workew
  },
  {
    name: 'Nomad Summit',
    description:
      'Nomad Summit is one of the biggest annual digital nomad conferences in the world.',
    website: 'http://www.nomadsummit.com',
    logo: nomadSummit
  },
  {
    name: 'e-Residency',
    description:
      'Estonian e-Residency allows digital entrepreneurs to manage business easily from anywhere, entirely online.',
    website: 'https://e-resident.gov.ee',
    logo: eResidency
  },
  {
    name: 'The Broke Backpacker',
    description:
      'The Broke Backpacker is the original backpacker´s bible, the Broke Backpacker has helped millions of people discover far flung lands and epic adventures without breaking the bank.',
    website: 'http://thebrokebackpacker.com',
    logo: theBrokeBackpacker
  },
  {
    name: 'Ruul',
    description:
      'Universal work and life solutions for talents and modern organizations willing to beat the obsolete and build the change in the remote reality.',
    website: 'https://ruul.io/',
    logo: ruul
  },
  {
    name: 'Hobo with a Laptop',
    description:
      'Hobo with a Laptop is an online resource that helps people who live alternative lifestyles make money online. From digital nomads to van life, an online income unites us all',
    website: 'https://hobowithalaptop.com',
    logo: hoboWithALaptop
  },
  {
    name: 'Hacker Paradise',
    description:
      'Hacker Paradise creates global remote-work expeditions for curious professionals who want to live, work, and adventure differently for one month to one year.',
    website: 'https://www.hackerparadise.org',
    logo: hackerParadise
  },
  {
    name: 'Coworker',
    description: 'Coworker.com helps you find your perfect coworking space.',
    website: 'https://www.coworker.com',
    logo: coWorker
  },
  {
    name: 'The Solo Female Traveler Network',
    description:
      'The Solo Female Traveler Network is a 100,000+ strong online community connecting gals of all ages with wanderlust in their hearts and stamps in their passports.',
    website: 'https://www.thesolofemaletravelernetwork.com',
    logo: soloFemale
  },
  {
    name: 'Xolo',
    description:
      'Xolo is a solution to start and remotely run your location-independent company online.',
    website:
      'https://www.xolo.io/?fp_ref=safetywing&utm_source=safetywing&utm_medium=web&utm_campaign=affiliate',
    logo: xolo
  },
  {
    name: 'MoneyCheck',
    description: 'MoneyCheck aims to simplify the world of finance, for Everyone.',
    website: 'https://moneycheck.com/',
    logo: moneyCheck
  },
  {
    name: 'Outsite',
    description: 'Coliving spaces, services and community for remote workers',
    website: 'https://www.outsite.co/?utm_campaign=Partner&utm_source=safetywing',
    logo: outsite
  },
  {
    name: 'A Broken Backpack',
    description:
      'A Broken Backpack is a website about long-term travel that helps people travel longer and further.',
    website: 'https://abrokenbackpack.com/',
    logo: aBrokenBackpack
  },
  {
    name: 'Nexstand',
    description:
      'Nexstand is the ergonomic answer to work from anywhere. Create the perfect mobile workstation so you can do your best work.',
    website: 'https://nexstand.io/',
    logo: nexstand
  },
  {
    name: 'firstbase',
    description: 'The simplest way to start, grow, and manage a US business.',
    website: 'https://firstbaseio.grsm.io/t64l92h42pwl',
    logo: firstbase
  },
  {
    name: 'Talanta',
    description:
      'Talanta enables companies to hire top early talent, anywhere in the world.',
    website: 'https://talanta.com',
    logo: talanta
  },
  {
    name: 'Techstars',
    description: 'The worldwide network that helps entrepreneurs succeed.',
    website: 'https://www.techstars.com',
    logo: techstars
  },
  {
    name: 'Flatworld',
    description:
      'Recruit for any role, anywhere. Get curated, interview-ready high-quality remote candidates in your inbox at a fraction of the cost of an agency with unprecedented speed.',
    website: 'https://flatworld.co',
    logo: flatworld
  }
];
